/** Where match map JSON comes from when a match starts. */
export enum MapDataSource {
  /** Tiled export fetched from CDN or a dev maps base URL. */
  Cdn = 'cdn',
  /** Generated in-process (stub or mode-specific builder); no remote `.json` fetch. */
  Procedural = 'procedural'
}

/** True when a match config opts into generated map JSON instead of CDN fetch. */
export function isProceduralMapConfig(matchConfig: { mapDataSource?: MapDataSource }): boolean {
  return matchConfig.mapDataSource === MapDataSource.Procedural;
}
